export default __webpack_public_path__ + "static/media/polygon.e989d2d6.svg";